import styled, { keyframes } from "styled-components";
import React from "react";

const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: ${(props) => (props.bar ? props.position[1] + "px" : "-70px")};
  left: ${(props) =>
    props.bar
      ? "calc(" + props.position[0] + "% - " + props.width / 2 + "px + 2.5%)"
      : "calc(" + props.position + "% - 33.5px)"};
  transition: left 500ms;
  font-family: "Red Hat Display", sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  color: #545454;
`;

const Bubble = styled.div`
  background-color: black;
  height: 35px;
  border-radius: 20px;
  width: 67px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const DoubleBubble = styled.div`
  background-color: black;
  height: 35px;
  border-radius: 20px;
  width: 85px;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Triangle = styled.div`
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid black;
  z-index: 3;
`;

const getPercentile = (s) => {
  let mod = s % 10;
  if (mod == 0 || mod > 3) {
    return s + "th";
  } else if (mod == 1) {
    return s + "st";
  } else if (mod == 2) {
    return s + "nd";
  } else if (mod == 3) {
    return s + "rd";
  }
};

const PercentileBubble = (props) => {
  if (props.style == "double") {
    return (
      <BubbleContainer
        position={props.position}
        bar={props.bar ? true : false}
        width={props.width}
      >
        <DoubleBubble>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              width: 40,
              borderRight: "1px solid white",
            }}
          >
            <div style={{ fontSize: 12 }}>
              {getPercentile(props.p1 > props.p2 ? props.p2 : props.p1)}
            </div>
            <div style={{ fontSize: 7 }}>
              {props.p1 > props.p2 ? props.t2 : props.t1}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              width: 40,
            }}
          >
            <div style={{ fontSize: 12 }}>
              {getPercentile(props.p1 > props.p2 ? props.p1 : props.p2)}
            </div>
            <div style={{ fontSize: 7 }}>
              {props.p1 > props.p2 ? props.t1 : props.t2}
            </div>
          </div>
        </DoubleBubble>
        <Triangle />
      </BubbleContainer>
    );
  }
  return (
    <BubbleContainer
      position={props.position}
      bar={props.bar ? true : false}
      width={props.width}
    >
      <Bubble>
        <div style={{ fontSize: 14 }}>
          {getPercentile(
            props.bar ? Math.floor(props.position[2]) : props.position
          )}
        </div>
        <div style={{ fontSize: 9 }}>{props.text}</div>
      </Bubble>
      <Triangle />
    </BubbleContainer>
  );
};

export default PercentileBubble;
